<template>
    <div>
        <div class="form-group">

            <p class="help-block">
                {{ $t("Calculette.result.info") }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-info',
};
</script>

<style scoped>

</style>
